import { useEffect, useState } from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import { Search } from 'lucide-react';
import { NavLink } from 'react-router-dom';
import type { NavigationItem } from './navigation';

function SearchResult({ item, onSelect }: { item: NavigationItem; onSelect: () => void }) {
  return item.external ? (
    <a href={item.to} onClick={onSelect} rel="noreferrer" target="_blank">
      {item.label}
    </a>
  ) : (
    <NavLink onClick={onSelect} to={item.to}>
      {item.label}
    </NavLink>
  );
}

export function NavigationSearch({ items }: { items: readonly NavigationItem[] }) {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState('');
  const normalizedQuery = query.trim().toLocaleLowerCase('zh-CN');
  const results = items.filter((item) =>
    item.label.toLocaleLowerCase('zh-CN').includes(normalizedQuery),
  );

  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === 'k') {
        event.preventDefault();
        setOpen(true);
      }
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, []);

  return (
    <Dialog.Root onOpenChange={setOpen} open={open}>
      <Dialog.Trigger asChild>
        <button aria-label="搜索页面" className="console-search-trigger" type="button">
          <Search aria-hidden size={15} />
          <span>搜索页面</span>
          <kbd>⌘ K</kbd>
        </button>
      </Dialog.Trigger>
      <Dialog.Portal>
        <Dialog.Overlay className="console-dialog-overlay" />
        <Dialog.Content aria-describedby={undefined} className="console-search-dialog">
          <Dialog.Title>前往页面</Dialog.Title>
          <input
            aria-label="搜索页面"
            autoFocus
            onChange={(event) => setQuery(event.target.value)}
            role="searchbox"
            value={query}
          />
          <nav aria-label="搜索结果">
            {results.length === 0 ? (
              <p>没有可用页面</p>
            ) : (
              results.map((item) => (
                <SearchResult item={item} key={item.id} onSelect={() => setOpen(false)} />
              ))
            )}
          </nav>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
